//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PromotionTournamentBottomMenu',
  props: {
    active: { type: String, default: 'ranking' },
    currentUserPosition: { type: [Number, String], default: '' },
    currentUserName: { type: String, default: '' },
    currentUserPoints: { type: String, default: '' },
    optedIn: { type: Boolean, default: false },
    optInLoading: { type: Boolean, default: false },
    disabledTabs: { type: Array, default: () => [] }
  },
  data() {
    return {
      tabs: [
        { value: 'prizes', label: 'Prizes', icon: require('~/assets/icons/tournaments/prizes-icon.svg') },
        { value: 'markets', label: 'Deportes', icon: require('~/assets/icons/tournaments/sports-icon.svg') },
        { value: 'rules', label: 'Rules', icon: require('~/assets/icons/tournaments/rules-icon.svg') },
        { value: 'ranking', label: 'Ranking', icon: require('~/assets/icons/tournaments/ranking-icon.svg') }
      ]
    }
  }
}
